import { render, staticRenderFns } from "./TiltakHovedPage.vue?vue&type=template&id=5afac2de"
import script from "./TiltakHovedPage.vue?vue&type=script&lang=js"
export * from "./TiltakHovedPage.vue?vue&type=script&lang=js"
import style0 from "./TiltakHovedPage.vue?vue&type=style&index=0&id=5afac2de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports